import {  useEffect,useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios"; 
import "../../styles/owner/HomeOwner.css"; // Import the CSS file for styling
import BASE_URL from "../../BaseUrl";

export default function PlansSection({setMessage, setShowMessage}) {
    const [editPlan, setEditPlan] = useState(false);
    // State to hold the list of plans
    const [plans, setPlans] = useState([]);
    const [showNewPlan, setShowNewPlan] = useState(false);
    // State to hold the plan name input
    const [plan, setPlan] = useState({
        id:"",
        name: "",
        capacity: 0,
        students:0,
        assistants:0,
        oldPrice:0.0,
        price: 0.0
    });
    const [isReloading, setIsReloading] = useState(false);
    const navigate = useNavigate();


    

    useEffect(() => {
        axios.get(`${BASE_URL}/owner/plans`,{withCredentials: true})
        .then((response)=>{
            setPlans(response.data);
        }).catch((error)=>{
            navigate("/");
        })

    }, [isReloading,navigate]);


    const deletePlan = (planId) => {
        axios.delete(`${BASE_URL}/owner/plan?planId=${planId}`, { withCredentials: true })
        .then((response) => {
            setPlan({
                    id:"",
                    name: "",
                    capacity: 0,
                    students:0,
                    assistants:0,
                    oldPrice:0.0,
                    price: 0.0
                })
            setIsReloading(!isReloading); // toggle isReloading to refresh the plans list
        }).catch((error) => {
            setMessage(error.response.data || "An error occurred while deleting the plan.");
            setShowMessage(true);
        })
    }

    const NewPlan = ()=>{
        axios.post(`${BASE_URL}/owner/new-plan`,plan,{withCredentials:true})
        .then((response)=>{
            setPlan({
                id:"",
                name: "",
                capacity: 0,
                students:0,
                assistants:0,
                oldPrice:0.0,
                price: 0.0
            });
            setMessage(response.data);
            setShowMessage(true);
            setShowNewPlan(false);
            setIsReloading(!isReloading); 
        }).catch((error)=>{
            console.log(error);
        })
    }

    const updatePlan = () =>{
        axios.put(`${BASE_URL}/owner/update-plan`,plan, { withCredentials: true })
        .then((response) => {
            setPlan({
                id:"",
                name: "",
                capacity: 0,
                students:0,
                assistants:0,
                oldPrice:0.0,
                price: 0.0
            });
            setMessage(response.data);
            setShowMessage(true);
            setEditPlan(false);
            setIsReloading(!isReloading); // toggle isReloading to refresh the plans list
        }).catch((error) => {
            console.log(error);
            setEditPlan(false);
        })
    }
    return(
        <div className="admins-section-container" dir="rtl">
            <h2>الخطط والاسعار</h2> <button onClick={() => {setShowNewPlan(true)}}>خطة جديدة</button>
            <table className="admins-table">
                <thead>
                    <tr>
                        <th>اسم الخطة</th>
                        <th>تعديل</th>
                        <th>حذف</th>
                    </tr>
                </thead>
                <tbody>
                    {plans.map((plan)=>{
                        return (
                            <tr key={plan.id}>
                                <td>{plan.name}</td>
                                <td><button onClick={()=>{setPlan(plan);setEditPlan(true)}}>تعديل</button></td>
                                <td><button onClick={()=>{deletePlan(plan.id)}}>حذف</button></td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>


            {editPlan && (
                <div className="add-admin-form" dir="rtl">
                    <h3>تعديل الخطة</h3>
                    <label > اسم الخطة</label>
                    <input type="text" value={plan.name} onChange={(e) => setPlan({...plan, name:e.target.value})} />
                    <label>السعة</label>
                    <input 
                    type="number" 
                    value={plan.capacity} 
                    onChange={(e) => setPlan({ ...plan, capacity: e.target.value })} 
                    />

                    <label>الطلاب</label>
                    <input 
                    type="number" 
                    value={plan.students} 
                    onChange={(e) => setPlan({ ...plan, students: e.target.value })} 
                    />

                    <label>المساعدين</label>
                    <input 
                    type="number" 
                    value={plan.assistants} 
                    onChange={(e) => setPlan({ ...plan, assistants: e.target.value })} 
                    />

                    <label>السعر القديم</label>
                    <input 
                    type="number" 
                    value={plan.oldPrice} 
                    onChange={(e) => setPlan({ ...plan, oldPrice: e.target.value })} 
                    />

                    <label>السعر</label>
                    <input 
                    type="number" 
                    value={plan.price} 
                    onChange={(e) => setPlan({ ...plan, price: e.target.value })} 
                    />
                    <button onClick={updatePlan}>تحديث</button>
                    <button onClick={() =>{ 
                        setPlan({
                            id:"",
                            name: "",
                            capacity: 0,
                            students:0,
                            assistants:0,
                            oldPrice:0.0,
                            price: 0.0
                        });
                        setEditPlan(false)}}>إلغاء</button>
                </div>
            )}



            {showNewPlan && (
                <div className="add-admin-form" dir="rtl">
                    <h3>خطة جديدة</h3>
                    <label > اسم الخطة</label>
                    <input type="text" value={plan.name} onChange={(e) => setPlan({...plan, name:e.target.value})} />
                    <label>السعة</label>
                    <input 
                    type="number" 
                    value={plan.capacity} 
                    onChange={(e) => setPlan({ ...plan, capacity: e.target.value })} 
                    />

                    <label>الطلاب</label>
                    <input 
                    type="number" 
                    value={plan.students} 
                    onChange={(e) => setPlan({ ...plan, students: e.target.value })} 
                    />

                    <label>المساعدين</label>
                    <input 
                    type="number" 
                    value={plan.assistants} 
                    onChange={(e) => setPlan({ ...plan, assistants: e.target.value })} 
                    />

                    <label>السعر القديم</label>
                    <input 
                    type="number" 
                    value={plan.oldPrice} 
                    onChange={(e) => setPlan({ ...plan, oldPrice: e.target.value })} 
                    />

                    <label>السعر</label>
                    <input 
                    type="number" 
                    value={plan.price} 
                    onChange={(e) => setPlan({ ...plan, price: e.target.value })} 
                    />
                    <button onClick={NewPlan}>إضافة</button>
                    <button onClick={() => {setPlan({
                            id:"",
                            name: "",
                            capacity: 0,
                            students:0,
                            assistants:0,
                            oldPrice:0.0,
                            price: 0.0
                        });setShowNewPlan(false)}}>إلغاء</button>
                </div>
            )}

        </div>

    )
}
